import { fetcher } from 'api/swr'
import { useEditorStore } from 'CanvasCore/uiSlice'
import { useUI } from 'Editor'

type OutfitDrawer = {
  cid?: string
  lid?: string
  t?: string
  [key: string]: unknown
}

type OutfitTonings = Record<string, unknown>

export type StaticOutfit = {
  drawers?: OutfitDrawer[]
  tonings?: OutfitTonings
}

type LayerRef = {
  id?: string
  toning?: string
}

function bindOutfitTonings(
  drawers: OutfitDrawer[],
  tonings: OutfitTonings,
  layers: LayerRef[],
): { drawers: OutfitDrawer[]; tonings: OutfitTonings } {
  const layerById = new Map(
    (layers || []).filter((l) => l?.id).map((l) => [l.id as string, l]),
  )
  const nextTonings: OutfitTonings = { ...(tonings || {}) }
  const nextDrawers = (drawers || []).map((drawer) => {
    const layer = drawer.lid ? layerById.get(drawer.lid) : undefined
    if (!layer?.toning) return drawer
    const nextT = layer.toning
    const prevT = drawer.t
    if (prevT && prevT !== nextT && nextTonings[prevT] && !nextTonings[nextT]) {
      nextTonings[nextT] = nextTonings[prevT]
    }
    if (drawer.t === nextT) return drawer
    return { ...drawer, t: nextT }
  })
  return { drawers: nextDrawers, tonings: nextTonings }
}

function syncToningUi(drawers: OutfitDrawer[]) {
  const lid = useUI.getState().lid
  const fromLayer = drawers.find((d) => d.lid === lid && d.t)
  const any = drawers.find((d) => d.t)
  const toningId = fromLayer?.t || any?.t || null
  if (toningId) {
    useUI.setState({ toningId })
  }
}

/** 把静态 avatar 的 drawers/tonings 写进编辑器，并按当前层绑定补齐 drawer.t */
export async function applyStaticOutfitToEditor(
  tid: string,
  outfit: StaticOutfit,
): Promise<void> {
  let layers: LayerRef[] = []
  try {
    layers = (await fetcher(['/layers', { tid }])) || []
  } catch {
    layers = []
  }

  const { drawers, tonings } = bindOutfitTonings(
    outfit.drawers || [],
    outfit.tonings || {},
    layers,
  )
  const { setDrawers, setTonings } = useEditorStore.getState()
  setDrawers(tid, drawers)
  setTonings(tid, tonings)
  syncToningUi(drawers)
}
